import { render } from "./AdvisorDetail.vue?vue&type=template&id=ea78ef1a"
import script from "./AdvisorDetail.vue?vue&type=script&lang=js"
export * from "./AdvisorDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__